import MyService from '../../service';

const MotorbikeApi = {
  createMotorbike: async (data) => {
    let result = null;
    result = await MyService.postRequestData('/motorbike', data);
    return result;
  },
  getDetailVehicle: async (vhc_id) => {
    let result = null;
    result = await MyService.getRequestData('/motorbike/get-detail-vehicle', {
      vhc_id,
    });
    return result ? result.data : result;
  },
  editMotorbike: async (data) => {
    let result = null;
    result = await MyService.postRequestData('/motorbike/edit-motorbike', data);
    return result;
  },
};

export default MotorbikeApi;
